import { RelatedSectionStore } from './RelatedSectionStore.js';
import RelatedProductStore from './RelatedProductStore.js';

/**
 * @typedef {import('../../../types').RelatedProductsProduct} RelatedProductsProduct
 * @typedef {import('../../RootStore').RootStore} RootStore
 */

export class RelatedRootStore {
  /** @type { { [skuId: string]: RelatedProductStore } } */
  relatedProductStores = {};
  localeObj

  constructor(localeObj, rootStore) {
    this.relatedSectionStores = {};
    this.rootStore = rootStore;
    this.localeObj = localeObj
  }

  /**
   * @param {string} productSkuID
   */
  getRelatedSectionStore = (productSkuID) => {
    if (!this.relatedSectionStores[productSkuID]) {
      this.relatedSectionStores[productSkuID] = new RelatedSectionStore(productSkuID, this.rootStore, this.localeObj);
      this.relatedSectionStores[productSkuID].initStore();
    }

    return this.relatedSectionStores[productSkuID];
  };

  getRelatedProductStore = (relatedProductSkuID) => this.relatedProductStores[relatedProductSkuID];

  /**
   * @param {RelatedProductsProduct} relatedProductData
   * @param {string} groupId
   */
  createRelatedProductStore = (relatedProductData, groupId) => {
    const { skuId } = relatedProductData.product;

    if (!this.relatedProductStores[skuId]) {
      this.relatedProductStores[skuId] = new RelatedProductStore(relatedProductData, this.rootStore, groupId, this.localeObj);
    }
  }
}
